import React, { useContext } from 'react'
import LayoutMain from '../layouts/Main'
import LayoutBase from '../layouts/Base'
import ConectarConecta from '../components/ConectarConecta'
import { ApiDataWrapperContext } from '../contexts/ApiDataWrapper'

// A credencial é lida aqui dentro do LayoutBase (é ele que monta o contexto).
function Conteudo() {
  const { getCredentials } = useContext(ApiDataWrapperContext)
  const { api, secret } = getCredentials()
  return <ConectarConecta api={api} secret={secret} />
}

export default function ConectarConectaPage() {
  return (
    <LayoutBase>
      <LayoutMain>
        <Conteudo />
      </LayoutMain>
    </LayoutBase>
  )
}
